<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="visible"
      direction="rtl"
      size="90%"
      ref="drawer"
      :wrapperClosable="false"
      :show-close="false"
    >
      <el-form
        ref="formRef"
        label-position="top"
        :model="formData"
        :rules="rules"
        :disabled="look ? true : false"
        style="padding: 10px"
      >
        <el-row :gutter="12">
          <el-col :span="16">
            <el-card>
              <el-row type="flex">
                <el-col :span="10">
                  <el-form-item label="项目名称" prop="project_name">
                    <el-input
                      placeholder="请填写项目名称"
                      :maxlength="128"
                      v-model="formData.project_name"
                      style="width: 80%"
                      size="small"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="项目周期" prop="project_cycle">
                    <el-input-number
                      placeholder="根据项目时间自动生成周期/月"
                      :min="0"
                      v-model="formData.project_cycle"
                      style="width: 80%"
                      size="small"
                      controls-position="right"
                      disabled
                    ></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="项目起止时间" prop="regdate_start">
                <el-row type="flex">
                  <el-col :span="10">
                    <el-date-picker
                      v-model="formData.regdate_start"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择项目开始日期"
                      style="width: 80%"
                      size="small"
                      @change="setStartTime"
                      :picker-options="startTimeOption"
                    ></el-date-picker>
                  </el-col>
                  <el-col :span="10">
                    <el-date-picker
                      v-model="formData.regdate_end"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择项目结束日期"
                      style="width: 80%"
                      size="small"
                      @change="setEndTime"
                      :picker-options="endTimeOption"
                    ></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-row type="flex">
                <el-col :span="10">
                  <el-form-item label="预算总金额" prop="total_funds_amount">
                    <el-input-number
                      placeholder="根据项目预算总金额"
                      v-model="formData.total_funds_amount"
                      style="width: 80%"
                      size="small"
                      :max="999999999"
                      controls-position="right"
                    ></el-input-number>
                    <p v-if="DX(formData.total_funds_amount)">
                      人民币：{{ DX(formData.total_funds_amount) }}
                    </p>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item label="是否需要医保" prop="if_quality">
                    <el-radio-group v-model="formData.if_quality" size="small">
                      <el-radio :label="1" border>是</el-radio>
                      <el-radio :label="2" border>否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="项目简介" prop="description">
                <el-input
                  placeholder="请填写项目描述"
                  :maxlength="200"
                  style="width: 80%"
                  size="small"
                  type="textarea"
                  :rows="3"
                  v-model="formData.description"
                />
              </el-form-item>

              <el-form-item label="救助对象" prop="fund_use">
                <el-input
                    style="width: 80%"
                    v-model="formData.fund_use"
                    placeholder
                    :maxlength="200"
                    type="textarea"
                    :rows="3"
                  />
              </el-form-item>

              

              <el-form-item label="覆盖范围" prop="address">
                <el-table border :data="formData.address">
                  <el-table-column prop="province_data" label="省">
                    <template slot-scope="scope">
                      <el-select
                        v-model="formData.address[scope.$index].province_data"
                        size="small"
                        placeholder="请选择省份"
                        disabled
                        value-key="value"
                      >
                        <el-option
                          v-for="item in provinceList"
                          :key="item.value"
                          :label="item.label"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column prop="city_id" label="市">
                    <template slot-scope="scope">
                      <el-select
                        v-model="formData.address[scope.$index].city_data"
                        size="small"
                        placeholder="请选择城市"
                        @change="getCounty($event, scope.$index)"
                        value-key="value"
                        :clearable="true"
                      >
                        <el-option
                          v-for="item in cityList"
                          :key="item.value"
                          :label="item.label"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column prop="county_id" label="区/县">
                    <template slot-scope="scope">
                      <el-select
                        v-model="formData.address[scope.$index].county_data"
                        size="small"
                        placeholder="请选择区县"
                        @change="getCountyLabel($event, scope.$index)"
                        value-key="value"
                        :clearable="true"
                      >
                        <el-option
                          v-for="item in countyList[scope.$index]"
                          :key="item.value"
                          :label="item.label"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column width="100" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-button
                        type="primary"
                        size="small"
                        @click="addAddressCol"
                        >新增</el-button
                      >
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        type="danger"
                        size="small"
                        @click="delAddressCol(scope.$index)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>

              <el-form-item label="救助标准" prop="funds">
                <el-table border :columns="fundsCols" :data="formData.funds">
                  <el-table-column
                    prop="cost_item"
                    label="救助类别"
                    width="150"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="formData.funds[scope.$index].cost_item_data"
                        size="small"
                        placeholder="请选择救助类别"
                        @change="getCostText($event, scope.$index)"
                        value-key="value"
                        :clearable="true"
                      >
                        <el-option
                          v-for="item in salvageData"
                          :key="item.value"
                          :label="item.text"
                          :value="item"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>

                  <el-table-column prop="money" label="金额">
                    <template slot-scope="scope">
                      <el-select
                        v-model="formData.funds[scope.$index].unit_data"
                        size="small"
                        style="width: 30%"
                        @change="getUnitText($event, scope.$index)"
                        placeholder="选择单位"
                        :clearable="true"
                      >
                        <el-option
                          v-for="item in fundsUnit"
                          :key="item.value"
                          :label="item.text"
                          :value="item"
                        ></el-option>
                      </el-select>
                      <el-input-number
                        style="width: 30%; padding-left: 5px"
                        :max="999999"
                        size="small"
                        controls-position="right"
                        v-model="formData.funds[scope.$index].funds_start"
                        :min="0"
                        placeholder="金额小"
                      ></el-input-number
                      >-
                      <el-input-number
                        style="width: 30%; padding-left: 5px"
                        :max="999999"
                        size="small"
                        controls-position="right"
                        v-model="formData.funds[scope.$index].funds_end"
                        :min="0"
                        placeholder="金额大"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column width="100" align="center">
                    <template slot="header" slot-scope="scope">
                      <el-button
                        type="primary"
                        size="small"
                        @click="addFundsCol"
                        >新增</el-button
                      >
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        type="danger"
                        size="small"
                        @click="delFundsCol(scope.$index)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <!-- <div
                  style="
                    height: 100px;
                    line-height: 100px;
                    text-align: center;
                    margin-top: 5px;
                  "
                  v-show="formData.funds.length > 0"
                >
                  <span>救助对象：</span>
                  <el-input
                    style="width: 70%"
                    v-model="formData.fund_use"
                    placeholder
                    :maxlength="500"
                    type="textarea"
                    :rows="3"
                  />
                </div> -->
              </el-form-item>
            </el-card>
          </el-col>

          <el-col :span="8">
            <el-card>
              <p slot="title">合作方信息</p>

              <el-row type="flex">
                <el-col :span="10">
                  <el-form-item label="合作方名称" prop="collaborator_name">
                    <el-input
                      placeholder="请填写合作方名称"
                      :maxlength="128"
                      size="small"
                      v-model="formData.collaborator_name"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                  <el-form-item label="法人" prop="corporation">
                    <el-input
                      placeholder="请填写法人"
                      :maxlength="128"
                      v-model="formData.corporation"
                      size="small"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex">
                <el-col :span="10">
                  <el-form-item label="联系人" prop="contacts">
                    <el-input
                      placeholder="请填写项目名称"
                      :maxlength="128"
                      v-model="formData.contacts"
                      size="small"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                  <el-form-item label="收款单位名称" prop="payee_unit_name">
                    <el-input
                      placeholder="请填写收款单位名称"
                      :maxlength="128"
                      size="small"
                      v-model="formData.payee_unit_name"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex">
                <el-col :span="10">
                  <el-form-item label="收款单位联系人" prop="payee_contacts">
                    <el-input
                      placeholder="请填写收款单位联系人"
                      :maxlength="128"
                      size="small"
                      v-model="formData.payee_contacts"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                  <el-form-item
                    label="收款单位联系手机"
                    prop="payee_office_phone"
                  >
                    <el-input
                      placeholder="请填写收款单位联系手机"
                      :maxlength="128"
                      size="small"
                      v-model="formData.payee_office_phone"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex">
                <el-col :span="10">
                  <el-form-item label="收款单位开户行" prop="bank_name">
                    <el-input
                      placeholder="请填写收款单位开户行"
                      :maxlength="128"
                      size="small"
                      v-model="formData.bank_name"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="10" :offset="2">
                  <el-form-item label="收款单位开户名" prop="account_name">
                    <el-input
                      placeholder="请填写收款单位开户名"
                      :maxlength="128"
                      size="small"
                      v-model="formData.account_name"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex">
                <el-col :span="10">
                  <el-form-item label="收款单位账号" prop="account_number">
                    <el-input
                      placeholder="请填写收款单位账号"
                      :maxlength="128"
                      size="small"
                      v-model="formData.account_number"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="业务范围" prop="business_scope">
                <el-input
                  placeholder="请填写业务范围"
                  :maxlength="200"
                  type="textarea"
                  :rows="3"
                  size="small"
                  v-model="formData.business_scope"
                />
              </el-form-item>
            </el-card>

            <el-card style="margin-top: 10px">
              <el-form-item label="协议附件" required>
                <el-upload
                  ref="fileUploadsRef"
                  :action="uploadFileUrl"
                  :before-upload="beforeUploadFile"
                  :on-success="
                    (response, file, fileList) => {
                      handlerUpload(fileList, 'defFiles');
                    }
                  "
                  :on-remove="
                    (file, fileList) => {
                      handlerUpload(fileList, 'defFiles');
                    }
                  "
                  multiple
                  :file-list="defFiles"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </el-card>
          </el-col>
        </el-row>
      </el-form>

      <div class="demo-drawer-footer">
        <el-button
          type="primary"
          @click="submit"
          :loading="loading"
          icon="md-checkmark"
          v-if="!look"
          >提交</el-button
        >
        <el-button type="danger" @click="close" ghost icon="md-close">{{
          look ? "关闭" : "取消"
        }}</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "发起项目信息",
    },
    width: {
      type: [String, Number],
      default: "90",
    },
    id: {
      type: [String, Number],
      default: null,
    },
    look: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var checkStartTimeGroup = (rule, value, callback) => {
      if (
        typeof this.formData.regdate_start === "undefined" ||
        !this.formData.regdate_start
      ) {
        return callback(new Error("请选择项目开始时间！"));
      }
      if (
        typeof this.formData.regdate_end === "undefined" ||
        !this.formData.regdate_end
      ) {
        return callback(new Error("请选择项目结束时间！"));
      }
      return callback();
    };

    var checkAddressGroup = (rule, value, callback) => {
      if (
        typeof this.formData.address === "undefined" ||
        this.formData.address.length === 0
      ) {
        // return callback(new Error("请选择项目范围！"));
      } else {
        let len = this.formData.address.length;
        if (
          len > 0 &&
          !this.formData.address[len - 1].province_id &&
          !this.formData.address[len - 1].city_id
        ) {
          return callback(new Error("请完善第" + len + "条项目范围信息！"));
        }
      }
      return callback();
    };

    var checkFundsGroup = (rule, value, callback) => {
      if (
        typeof this.formData.funds === "undefined" ||
        this.formData.funds.length === 0
      ) {
        return callback(new Error("请选择救助标准！"));
      } else {
        let info = this.formData.funds;

        let bool = info.every((item, index, arr) => {
          // item为数组中的元素，index为下标，arr为目标数组
          if (
            !(
              item.cost_item &&
              item.unit &&
              item.funds_start &&
              item.funds_end &&
              item.funds_start <= item.funds_end
            )
          ) {
            return callback(
              new Error("救助标准中,第" + (index + 1) + "行信息填写有误！")
            );
          }
          return (
            item.cost_item &&
            item.unit &&
            item.funds_start &&
            item.funds_end &&
            item.funds_start <= item.funds_end
          );
        });
      }

      return callback();
    };
    var checkPhone = (rule, value, callback) => {
      let mobile = /^[1][0-9]{10}$/;
      if (this.formData.payee_office_phone) {
        if (!mobile.test(this.formData.payee_office_phone)) {
          return callback("手机号码格式不正确！");
        }
      }
      return callback();
    };

    return {
      visible: false,
      loading: false,
      uploadFileUrl: null,
      defFiles: [],
      formData: {
        project_name: null,
        total_funds_amount: null,
        description: null,
        if_quality: 1,
        address: [],
        funds: [],
        regdate_start: null,
        regdate_end: null,
        project_cycle: null,
        collaborator_name: null,
        corporation: null,
        contacts: null,
        payee_unit_name: null,
        payee_contacts: null,
        payee_office_phone: null,
        // payee_telephone: null,
        bank_name: null,
        account_name: null,
        account_number: null,
        business_scope: null,
        collaborator: {
          collaborator_name: null,
          corporation: null,
          contacts: null,
          payee_unit_name: null,
          payee_contacts: null,
          payee_office_phone: null,
          // payee_telephone: null,
          bank_name: null,
          account_name: null,
          account_number: null,
          business_scope: null,
        },
      },

      province_id_text: "",
      province_id: null, //省区id

      provinceList: [], //省列表
      cityList: [], //市列表
      countyList: [], //县列表

      poorTypeList: [], //贫困类型
      salvageData: [], //救助领域集合
      fundsUnit: [], //选择单位

      fundsCols: [
        {
          title: "救助类别",
          slot: "cost_item",
          align: "center",
        },
        {
          title: "单价",
          slot: "money",
          align: "center",
        },
        {
          slot: "action",
          width: 100,
          align: "center",
          renderHeader: (h, params) => {
            return h(
              "Button",
              {
                props: { type: "primary", size: "small" },
                on: {
                  click: () => {
                    this.addFundsCol();
                  },
                },
              },
              "添加"
            );
          },
        },
      ],
      rules: {
        project_name: [
          { required: true, message: "项目名称不能为空！", trigger: "blur" },
        ],
        total_funds_amount: [
          {
            required: true,
            type: "number",
            message: "预算总金额不能为空！",
            trigger: "blur",
          },
        ],
        fund_use: [
          {
            required: true,
            message: "救助对象不能为空！",
            trigger: "blur",
          },
        ],
        regdate_start: [
          {
            required: true,
            message: "项目开始日期不能为空！",
            trigger: "change",
          },
          { validator: checkStartTimeGroup, trigger: "change" },
        ],
        address: [
          {
            required: true,
            type: "array",
            message: "覆盖范围不能为空！",
            trigger: "change"
          },
          { validator: checkAddressGroup, trigger: "change" }
        ],
        funds: [
          {
            required: true,
            type: "array",
            message: "救助标准不能为空！",
            trigger: "change",
          },
          { validator: checkFundsGroup, trigger: "change" },
        ],
        collaborator_name: [
          { required: true, message: "合作方名称不能为空！", trigger: "blur" },
        ],
        corporation: [
          { required: true, message: "法人不能为空！", trigger: "blur" },
        ],
        contacts: [
          { required: true, message: "联系人不能为空！", trigger: "blur" },
        ],
        payee_unit_name: [
          {
            required: true,
            message: "收款单位名称不能为空！",
            trigger: "blur",
          },
        ],
        payee_contacts: [
          { required: true, message: "收款联系人不能为空！", trigger: "blur" },
        ],
        payee_office_phone: [
          {
            required: true,
            message: "收款单位联系手机不能为空！",
            trigger: "blur",
          },
          { validator: checkPhone, trigger: "blur" },
        ],
        bank_name: [
          {
            required: true,
            message: "收款单位开户行不能为空！",
            trigger: "blur",
          },
        ],
        account_name: [
          {
            required: true,
            message: "收款单位开户名不能为空！",
            trigger: "blur",
          },
        ],
        account_number: [
          {
            required: true,
            message: "收款单位账号不能为空！",
            trigger: "blur",
          },
        ],
      },
      endTimeOption: {}, //结束时间参数配置
      startTimeOption: {}, //开始时间参数配置
    };
  },
  methods: {
    close() {
      this.visible = false;
    },

    beforeUploadFile(file) {
      let bool = this.$fnc.checkUploadFile(file);
      return bool;
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    //金额转成大写
    DX(n) {
      if (Number(n) > 0) {
        if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "";
        var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
          str = "";
        n += "00";
        var p = n.indexOf(".");
        if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
        unit = unit.substr(unit.length - n.length);
        for (var i = 0; i < n.length; i++)
          str += "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
        return str
          .replace(/零(仟|佰|拾|角)/g, "零")
          .replace(/(零)+/g, "零")
          .replace(/零(万|亿|元)/g, "$1")
          .replace(/(亿)万|壹(拾)/g, "$1$2")
          .replace(/^元零?|零分/g, "")
          .replace(/元$/g, "元整");
      } else {
        return false;
      }
    },

    setStartTime(val) {
      this.formData.regdate_start = val;

      if (this.formData.regdate_start && this.formData.regdate_end) {
        this.getIntervalMonth();
      }

      this.endTimeOption = {
        //时间约束
        disabledDate: (date) => {
          let startTime = this.formData.regdate_start
            ? new Date(this.formData.regdate_start).valueOf()
            : "";
          return date && date.valueOf() < startTime;
        },
      };
    },
    setEndTime(val) {
      this.formData.regdate_end = val;

      if (this.formData.regdate_start && this.formData.regdate_end) {
        this.getIntervalMonth();
      }

      let endTime = this.formData.regdate_end
        ? new Date(this.formData.regdate_end).valueOf() -
          1 * 24 * 60 * 60 * 1000
        : "";
      if (endTime) {
        //时间约束
        this.startTimeOption = {
          disabledDate(date) {
            return date && date.valueOf() > endTime;
          },
        };
      }
    },

    getIntervalMonth() {
      var startMonth = new Date(Date.parse(this.formData.regdate_start));
      var endMonth = new Date(Date.parse(this.formData.regdate_end));

      var intervalMonth =
        endMonth.getFullYear() * 12 +
        endMonth.getMonth() -
        (startMonth.getFullYear() * 12 + startMonth.getMonth());
      var day = endMonth.getDate() - startMonth.getDate();
      if (day > 0) {
        intervalMonth += 1;
      }
      intervalMonth > 0 &&
        this.$set(this.formData, "project_cycle", intervalMonth);
    },

    submit() {
      if (this.defFiles.length) {
        let arr = [];

        this.defFiles.forEach((item, index) => {
          if (item.hasOwnProperty("response")) {
            arr.push(item.response.data.id);
          } else {
            arr.push(item.id);
          }
        });
        this.formData.donation_files = arr;
      } else {
        return this.$message.warning("请上传协议附件！");
      }
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.formData.collaborator.collaborator_name = this.formData.collaborator_name;
          this.formData.collaborator.corporation = this.formData.corporation;
          this.formData.collaborator.contacts = this.formData.contacts;
          this.formData.collaborator.payee_unit_name = this.formData.payee_unit_name;
          this.formData.collaborator.payee_contacts = this.formData.payee_contacts;
          this.formData.collaborator.payee_office_phone = this.formData.payee_office_phone;
          this.formData.collaborator.bank_name = this.formData.bank_name;
          this.formData.collaborator.account_name = this.formData.account_name;
          this.formData.collaborator.account_number = this.formData.account_number;
          this.formData.collaborator.business_scope = this.formData.business_scope;

          let url;
          this.loading = true;

          //合作项目
          if (this.id > 0) {
            url = this.$db.config.com_project.launch.update;
          } else {
            url = this.$db.config.com_project.launch.insert;
          }

          this.$db.post(url, this.formData).then((res) => {
            this.loading = false;
            if (res && res.code == 200) {
              this.close();
              this.$message.success(res.msg);
              this.$emit("success");
            }
          });
        } else {
          return this.$message.warning("请填写完整的表单信息！");
        }
      });
    },

    //市
    getCity() {
      // if (!if_edit) {
      //   this.formData.address[index].city_id = null;
      //   this.formData.address[index].city_id_text = null;
      //   this.formData.address[index].county_id = null;
      //   this.formData.address[index].county_id_text = null;
      // }

      let params = { level: 2, pid: this.province_id };
      this.$db.post(this.$db.config.getRegionUrl, params).then((resp) => {
        if (resp && resp.code == 200) {
          this.$set(this, "cityList", resp.data);
        }
      });
    },
    //县
    getCounty(data, index, if_edit = false) {
      this.formData.address[index].city_id = data.value;
      if (!if_edit) {
        this.formData.address[index].city_id_text = data.label;
        this.formData.address[index].county_id = null;
        this.formData.address[index].county_id_text = null;
      }

      let params = { level: 3, pid: data.value };
      this.$db.post(this.$db.config.getRegionUrl, params).then((resp) => {
        if (resp && resp.code == 200) {
          if (index >= 0) {
            this.$set(this.countyList, index, resp.data);
          }
        }
      });
    },
    //获取区县文字
    getCountyLabel(data, index) {
      this.formData.address[index].county_id = data.value;
      this.formData.address[index].county_id_text = data.label;
    },

    //增加项目范围
    addAddressCol() {
      let len = this.formData.address.length;

      if (len && len > 0) {
        if (
          !this.formData.address[len - 1].province_id &&
          !this.formData.address[len - 1].city_id
        ) {
          return this.$message.warning("请先完善上一行信息，再执行该操作！");
        }
      }
      let pushArr = {
        province_id: this.province_id > 0 ? this.province_id : null,
        province_data:
          this.province_id > 0
            ? { value: this.province_id, label: this.province_id_text }
            : {},
        province_id_text: this.province_id > 0 ? this.province_id_text : null,
        city_id: null,
        city_data: {},
        city_id_text: null,
        county_id: null,
        county_data: {},
        county_id_text: null,
      };
      this.formData.address.push(pushArr);
    },
    //删除项目范围
    delAddressCol(index) {
      this.formData.address.splice(index, 1);
    },
    //项目范围相关 end

    //获取疾病类别文字
    getCostText(data, index) {
      this.formData.funds[index].cost_item = data.value;
      this.formData.funds[index].cost_item_text = data.text;
    },

    //获取单位文字
    getUnitText(data, index) {
      this.formData.funds[index].unit = data.value;
      this.formData.funds[index].unit_text = data.text;
    },

    //救助标准相关 start
    //添加一行救助标准
    addFundsCol() {
      let len = this.formData.funds.length;
      if (len > 0) {
        let info = this.formData.funds[len - 1];
        if (!info.cost_item || !info.unit) {
          return this.$message.warning("请先完善上一行信息，再执行该操作！");
        }
        if (info.funds_start && info.funds_end) {
          if (info.funds_start > info.funds_end) {
            return this.$message.warning("救助标准金额区间有误！");
          }
        } else {
          return this.$message.warning("请填写第" + len + "救助标准金额区间！");
        }
      }
      let pushArr = {
        cost_item: null,
        cost_item_data: {},
        unit: null,
        unit_data: {},
        funds_start: null,
        funds_end: null,
      };

      this.formData.funds.push(pushArr);
    },
    //救助标准删除一行
    delFundsCol(index) {
      this.formData.funds.splice(index, 1);
    },
    //救助标准相关 end

    //编辑信息
    getEditInfo() {
      let url;
      url = this.$db.config.com_project.launch.info;

      this.$db.post(url, { id: this.id }).then((res) => {
        if (res && res.code == 200) {
          this.formData = res.data;
          this.formData.total_funds_amount = Number(
            res.data.total_funds_amount
          );

          if (res.data.donation_files_path.length) {
            this.defFiles = res.data.donation_files_path;
          }
          this.$set(
            this.formData,
            "collaborator_name",
            res.data.collaborator.collaborator_name
          );
          this.$set(
            this.formData,
            "corporation",
            res.data.collaborator.corporation
          );
          this.$set(this.formData, "contacts", res.data.collaborator.contacts);
          this.$set(
            this.formData,
            "payee_unit_name",
            res.data.collaborator.payee_unit_name
          );
          this.$set(
            this.formData,
            "payee_contacts",
            res.data.collaborator.payee_contacts
          );
          this.$set(
            this.formData,
            "payee_office_phone",
            res.data.collaborator.payee_office_phone
          );
          this.$set(
            this.formData,
            "bank_name",
            res.data.collaborator.bank_name
          );
          this.$set(
            this.formData,
            "account_name",
            res.data.collaborator.account_name
          );
          this.$set(
            this.formData,
            "account_number",
            res.data.collaborator.account_number
          );
          this.$set(
            this.formData,
            "business_scope",
            res.data.collaborator.business_scope
          );

          //操作项目范围
          res.data.address.forEach((value, index) => {
            if (value.province_id) {
              this.formData.address[index].province_id = value.province_id;
              this.formData.address[index].province_id_text =
                value.province_id_text;
            }

            if (value.city_id) {
              this.formData.address[index].city_id = value.city_id;
              this.formData.address[index].city_id_text = value.city_id_text;
              this.getCounty({ value: value.city_id }, index, true);
            }
            if (value.county_id) {
              this.formData.address[index].county_id = value.county_id;
              this.formData.address[index].county_id_text =
                value.county_id_text;
            }
          });
        }
      });
    },

    //获取字典表数据
    getDictData() {
      //费用项目
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100170,
          table: "pub_type_param",
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.salvageData = res.data;
          }
        });
      //费用单位
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100310,
          table: "pub_type_param",
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.fundsUnit = res.data;
          }
        });

      //贫困类型
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 100380,
          table: "pub_type_param",
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.poorTypeList = res.data;
          }
        });
    },
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },
  },

  mounted() {
    this.visible = true;
    this.formData.type = 2;
    this.getDictData();
    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
    this.province_id = JSON.parse(
      sessionStorage.getItem("unitAuth")
    ).province_id;
    this.province_id_text = JSON.parse(
      sessionStorage.getItem("unitAuth")
    ).province_id_text;
    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then((resp) => {
      if (resp && resp.code == 200) {
        this.provinceList = resp.data;
      }
    });
    this.getCity();
    if (this.id > 0) {
      this.getEditInfo();
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__body {
  overflow-y: auto;
  padding-bottom: 100px;
}

.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/launch/info.vue